// extracted by mini-css-extract-plugin
export default {"nonCheckableParent":"dummy-checkbox_nonCheckableParent__V0Tgr","dummyCheckbox":"dummy-checkbox_dummyCheckbox__ika8j","indeterminate":"dummy-checkbox_indeterminate__QXFR6"};